
<p-dialog class="create-scenario-popup" 
    header="Create a custom scenario" 
    [visible]="isVisible"
    [modal]="true"
    [closable]="true" 
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    [style]="{ width: '800px', maxWidth: '90vw' }"
    [breakpoints]="{ '960px': '90vw', '640px': '96vw' }"
    [contentStyle]="{ overflow: 'visible' }"
    [styleClass]="'create-scenario-size'" 
    (visibleChange)="onVisibleChange($event)"
    (onHide)="onCloseModal()">
    <div class="instructions-section">
        <span>Set a name and a base scenario. You can edit these values later in the inputs table if necessary.</span>
    </div>
    <div class="settings-section">
        <div class="input-section set-name">
            <label for="scenario-name-selector">Set scenario name:</label>
            <input id="scenario-name-selector" class="input-box" 
            [(ngModel)]="newColumnName" />
        </div>

        <div class="input-section set-base">
            <label for="base-scenario-selector">Select base scenario:</label>

            <p-select 
                inputId="base-scenario-selector"
                class="select-box"
                [options]="columns.slice(1)"
                optionLabel="header"
                [appendTo]="'body'"
                [ngModel]="selectedBaseScenario"
                (onChange)="onBaseScenarioChange($event.value)">
            </p-select>
        </div>

    </div>
    <div class="buttons-section">
        <button class="cancel-button formated-button" (click)="onCloseModal()">Cancel</button>
        <button class="accept-button formated-button" [disabled]="isAddButtonDisabled()"
            [ngClass]="isAddButtonDisabled() ? 'inactive-button' : 'active-button'"
            (click)="onAddColumn()">Create</button>
    </div>
</p-dialog>

